import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";
import { createGridConfig, gridMultiple, gridSimple } from "./gridSettings/gridSettings";
import { sedeForm } from "./sedeForm";


const empty = { type: 'empty', dataField: '', dataType: '' }


const uL_ElaboraMud = {
  type: 'campoSpecial', colVisible: false, dataField: "elaboraMud", editorType: "dxSelectBox",
  caption: "Elabora MUD",
  nCol: 3,
  labelWidth: 94,
  lista: {
    dataSource: 'elaboraMUD',
    valueExpr: 'id',
    displayExpr: 'descrizione',
    static: true,
    items: [
      {
        id: 'S', descrizione: 'SI'
      },
      {
        id: 'N', descrizione: 'NO'
      }
    ]
  }
}

const uL_TipoMud = {
  type: 'campoSpecial', colVisible: false, dataField: "tipoMud", dataType: "", caption: "Tipo Mud",
  editorType: "dxSelectBox",
  maxLength: "3",
  maxSize: 1,

  nCol: 4,
  lista: {
    dataSource: 'tipoMUD',
    valueExpr: 'id',
    displayExpr: 'descrizione',
    static: true
  }
}
const UL_stato = {
  orderGriglia: 8,
  type: 'campoSpecial', dataField: "UL_stato", dataType: "", caption: "Stato",
  colVisible: false,
  nCol:3, 
  
  labelWidth:96,
  lista: {
    dataSource: 'statoEstero',
    valueExpr: 'iso',
    displayExpr: 'descrizione',
     static: false

  },
  
  editorType: 'dxSelectBox'
}

const configuration = {
  configuration:
  {
    titleGriglia: 'Filtri Avanzati',
    titleForm: '$filtriavanzati',
    breadcrumbCaption: 'Filtri Avanzati',
    campoTitle: ['filtriAvanzati'],
    masterKey: 'id',
    service: 'nomeTemplate',
    api: 'nomeTemplate',
    filterList: '?NomeTabella=$NomeTabella&IdTabella=$IdTabella',
    helpDoc: '#',
    queryFilter: [],
    filterEditor: '/$',
    formType: 'simple',
    idTabRif: [],
    nCol: 2,
  }
}

let sediMd = JSON.parse(JSON.stringify(sedeForm));
sediMd = sediMd.filter(reeeeeee=>reeeeeee.itemType == 'group')

sediMd = sediMd.filter((resColS,x) => {
    
  if(x >= 1){
    return false;
  }

  let colSpanG = 0;
  if(x == 1){
    colSpanG = Number(resColS.colCount);
    resColS.groupWidth=750
    resColS.caption = 'Dati UL';
  }
  
 
  
  colSpanG = Number(resColS.colCount)
  

  const newDataS = []; // Nuovo array per contenere i dati con l'aggiunta
  resColS.data.forEach(di => {
  
  const colSpan = Number(di.colSpan);

  if(di.type == 'empty' && di.nCol >0){
    delete di.nCol
  }
  if(di.type == 'empty' && di.caption > " " && colSpan  ==  colSpanG){
     di.dataField ='emptyno'
  } 

  switch (di.dataField) {
    case 'riferimentoEsterno':
      di = empty
      newDataS.push(uL_ElaboraMud)
      newDataS.push(uL_TipoMud)
      newDataS.push(empty)
      newDataS.push(empty)
      newDataS.push(empty)
    break
    case 'emptyno':
      di = null
     case 'civico': 
     case 'istatComune': 
     case 'numeroIscrizioneAlbo':
     case 'protocolloAlbo':
     case 'dataIscrizioneAlbo':
     case 'copiaDatiAzienda':
     case 'descrizione':
     case 'indirizzo':
     case 'frazione':
     case 'riferimentoEsterno':
     case 'nota':
     case 'tipoMud':
     case 'cciiaa':
     case 'ateco':
     case 'rea':
     case 'addetti':
     case 'mesiAttivita':
     case 'rappresentanteNome':
     case 'rappresentanteCognome':
     case 'idSedeRentri':
     case 'latidudine':
     case 'longitudine':
      di = empty
     break;
     case 'idCategoria':
     case 'idTipo':
     case 'idZona':
      di.dynamic.settingGrid = gridMultiple;
      if(di.dataField == 'idZona'){
        newDataS.push(UL_stato)
        newDataS.push(empty)
        newDataS.push(empty)
        newDataS.push(empty)
        newDataS.push(empty)
      }
      
      break;
      case 'comune':
        di.labelWidth =95
        di.dynamic.related = ['cap|UL_cap', 'siglaProvincia|UL_siglaProvincia']
        delete di.validation;
      break;
      case 'stato':
        di = null
      break
   
      case 'dataChiusuraImpiantoMobile':
        di.disableOnUpdate = false;
        di.disabled = false;
        // d.labelWidth=160
      break;
    default:
      delete di.validation;
      delete di.labelWidth;
   break;
  }

  if(di){
    di.dataField = 'UL_' + di.dataField 
    di.labelWidth =95
    newDataS.push(di); // Aggiungi l'elemento corrente a newData
  }
});

  resColS.data = newDataS; // Assegna il nuovo array di dati modificati a resCol.data
  return true; // Restituisci true per mantenere resCol nell'array filtrato
})


sediMd.unshift(configuration)

export const unitaLocaliFiltri = sediMd

/* export const unitaLocaliFiltri: AnaColumn[] = [

  {
    configuration:
    {
      titleGriglia: 'Filtri Avanzati',
      titleForm: '$filtriavanzati',
      breadcrumbCaption: 'Filtri Avanzati',
      campoTitle: ['filtriAvanzati'],
      masterKey: 'id',
      service: 'nomeTemplate',
      api: 'nomeTemplate',
      filterList: '?NomeTabella=$NomeTabella&IdTabella=$IdTabella',
      helpDoc: '#',
      queryFilter: [],
      filterEditor: '/$',
      formType: 'simple',
      idTabRif: [],
      nCol: 2,
    }
  },
  {
    //IL COLSPAN È RIFERITO ALLA PROPRIETA NGCOL
    itemType: "group", caption: "Unità Locale", colCount: "6", class: 'w-100 mt-4 mb-4', data: [
      {
        type: 'campo', nCol: 1, labelWidth: 100, dataField: "ul_isProduttore", dataType: "boolean", caption: "Produttore", editorType: "dxCheckBox", colVisible: false,
      },
      {
        type: 'campo', nCol: 1, labelWidth: 100, dataField: "ul_isTrasportatore", dataType: "boolean", caption: "Trasportatore", editorType: "dxCheckBox", colVisible: false,
      },
      {
        type: 'campo', nCol: 1, labelWidth: 100, dataField: "ul_isDestinatarioRifiuto", dataType: "boolean", caption: "Destinatario", editorType: "dxCheckBox", colVisible: false,
      },
      {
        type: 'campo', labelWidth: 100, nCol: 1, dataField: "ul_isIntermediario", dataType: "boolean", caption: "Intermediario", editorType: "dxCheckBox", colVisible: false,
      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "uL_elaboraMud", editorType: "dxSelectBox",
        caption: "Elabora MUD",
        nCol: 2,
        labelWidth: 130,
        //class: 'text-uppercase',
        lista: {
          dataSource: 'elaboraMUD',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: true,
          items: [
            {
              id: 'S', descrizione: 'SI'
            },
            {
              id: 'N', descrizione: 'NO'
            }
          
          ]
        }
      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "uL_TipoMud", dataType: "", caption: "Tipo Mud",
        editorType: "dxSelectBox",
        maxLength: "3",
        maxSize: 1,
        labelWidth: 120,
        //class: 'text-uppercase',
        horizontalAlignment: 'left',
        nCol: 2,
        lista: {
          dataSource: 'tipoMUD',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: true
        }
      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "uL_TipoPCE",
        caption: "Tipo Azienda",
        maxLength: "2",
        maxSize: 2,
        labelWidth: 120,
        nCol: 4,
        hideOnEdit: false,
        editorType: 'dxSelectBox',
        //class: 'text-uppercase',
        lista: {
          dataSource: 'tipoPCE',
          valueExpr: 'id',
          displayExpr: 'descrizione', static: true
        },
      },
      { type: 'empty', dataField: '', dataType: '' },
      {
        type: 'campoSpecial', dataField: "uL_IdRegione", dataType: "", caption: "Regione",

        colVisible: false,
        nCol: 2,
        labelWidth: 130,
        disableOnUpdate: false,

        dynamic: {

          service: 'generic',
          dataSource: 'regione',
          autocomplete: false,

          valueExpr: '',//Lasciato Vuoto sen non serve l'id del DB
          displayExpr: 'descrizione',
          caption: "Regione",
          queryString: '?$orderby=Descrizione asc',
          componentType: 'dynamicGrid',
          //related: ['cap', 'siglaProvincia', 'id|istatComune'],

          buttonOption: {
            text: 'Regione',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Stati',
            name: 'Regione',
            location: 'after',
          },
          settingGrid: gridSimple,
        },
      },
      {
        type: 'campoSpecial', dataField: "uL_SiglaProvincia", dataType: "", caption: "Provincia",
        colVisible: true,
        editorType: 'dxSelectBox',
        labelWidth: 120,
        nCol: 2,
        maxSize: 5,
        dynamic: {

          service: 'provincia',
          dataSource: 'provincia',

          autocomplete: false,
          checkValue: {
            checkValueMessage: 'Provincia inesistente, vuoi continuare?',
            forceInsert: true
          },
          valueExpr: '',//Lasciato Vuoto sen non serve l'id del DB
          displayExpr: 'siglaProvincia',
          caption: "Provincia",
          queryString: '?$orderby=Descrizione',
          componentType: 'dynamicGrid',
          //related: ['cap', 'siglaProvincia', 'id|istatComune'],
          enableEditor: {
            add: false,
            remove: false,
            update: false
          },
          buttonOption: {
            text: 'Provincia',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia le Province',
            name: 'Provincia',
            location: 'after',
          },
          settingGrid: gridSimple,
        },
      },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },
      {
        type: 'campo', colVisible: true, dataField: "uL_Zona_Descrizione",
        dataType: "campo",
        nCol: 4,
        labelWidth: 120,
        caption: "Zona",
        editorType: '',
        dynamic: {

          dataSource: 'Zona',
          service: 'generic',
          autocomplete: false,

          valueExpr: '',//Lasciato Vuoto sen non serve l'id del DB
          displayExpr: 'descrizione',
          caption: "Zone",
          queryString: '?nomeTabella=SEDI',
          componentType: 'dynamicGrid',
          //related: ['cap', 'siglaProvincia', 'id|istatComune'],

          buttonOption: {
            text: 'Regione',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Stati',
            name: 'Regione',
            location: 'after',
          },
          settingGrid: gridSimple,
        },
      },
      {
        type: 'campoSpecial', dataField: "uL_Comune", caption: "Comune", dataType: "",
        colVisible: true,
        labelWidth: 120,
        maxSize: 45,
        nCol: 4,
        dynamic: {
          costantValue: [{ key: 'stato', value: 'IT' }],
          service: 'comune',
          dataSource: 'comune',
          autocomplete: false,
          checkValue: {
            checkValueMessage: 'Comune inesistente, vuoi continuare?',
            forceInsert: true
          },
          valueExpr: '',//Lasciato Vuoto sen non serve l'id del DB
          displayExpr: 'descrizione',
          caption: "Comuni",
          queryString: '?$orderby=Descrizione asc',
          componentType: 'dynamicGrid',
          //related: ['cap', 'siglaProvincia', 'id|istatComune'],
          enableEditor: {
            add: false,
            remove: false,
            update: false
          },
          buttonOption: {
            text: 'Comuni',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Comuni',
            name: 'Comuni',
            location: 'after',
          },
          settingGrid: createGridConfig({
            ...gridSimple,
            colonne: [
              { type: 'campo', dataField: "id", dataType: "string", caption: "ISTAT", colWidth: '55' },
              { type: 'campo', dataField: "descrizione", dataType: "", caption: "Comune", colWidth: '300' },
              { type: 'campo', dataField: "siglaProvincia", dataType: "string", caption: "PR.", colWidth: '40' },
              { type: 'campo', dataField: "cap", dataType: "string", caption: "CAP", colWidth: '70' },
            ]
          })
        }

      },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },
      {
        type: 'campoSpecial', colVisible: true, dataField: "uL_Categoria_Descrizione",
        dataType: "",
        caption: "Categoria",
        labelWidth: 120,
        nCol: 4,
        editorType: '',
        dynamic: {

          service: 'generic',
          dataSource: 'Categoria',
          autocomplete: false,

          valueExpr: '',//Lasciato Vuoto sen non serve l'id del DB
          displayExpr: 'descrizione',
          caption: "Categoria",
          queryString: '?nomeTabella=SEDI',
          componentType: 'dynamicGrid',
          //related: ['cap', 'siglaProvincia', 'id|istatComune'],
          related: ['id|uL_IdCategoria'],
          buttonOption: {
            text: 'Regione',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Stati',
            name: 'Regione',
            location: 'after',
          },
          settingGrid: gridSimple,
        },
    
      },
     
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },
      {
        type: 'campoSpecial', colVisible: true, dataField: "uL_IdTipo",
        dataType: "",
        nCol: 4,
        caption: "Tipo",
        labelWidth: 120,
        editorType: '',

        dynamic: {
          autocomplete: false,
          dataSource: 'tipo?nomeTabella=SEDI',
          displayExpr: 'descrizione',
          queryString: '?nomeTabella=SEDI',
          valueExpr: 'id',
          static: false,
          settingGrid: {
            colonne: [
              { dataField: 'descrizione', caption: 'Nome Tipo', dataType: '' }
            ]
          }
        },

      },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },
    ]
  },
] */